import { useContext } from 'react';
import { UserContext } from '../../contexts/contexts';

export const useUser = () => {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }

  const { userData, mood, isUserLoading } = context;

  return { userData, mood, isUserLoading };
};
